// extracted by mini-css-extract-plugin
export default {"component":"yGN2k"};